require('./brokerCustomWalletGroupedPortfolios.scss');
// @vendor
const React = require('react');
const PropTypes = require('prop-types');
const noop = require('lodash/utility/noop');

// @components
const { BrokerCustomWalletPortfolioItem } = require('../brokerCustomWalletPortfolioItem/brokerCustomWalletPortfolioItemContainer');

// @utils
const { formatText } = require('core/i18n').i18n;

// @commons
const { Toggle } = require('commonsComponents/toggle');

// @constants
const {
    BROKER_CUSTOM_WALLET_CONTRACT_FUNDS_TYPE,
    BROKER_CUSTOM_WALLET_CONTRACT_PLANS_TYPE,
    BROKER_CUSTOM_WALLET_CONTRACT_VALORES_TYPE,
} = require('../../constants/index');

class BrokerCustomWalletGroupedPortfolios extends React.Component {
    onGroupToggle(portfolioType, on) {
        const { onGroupToggleOn, onGroupToggleOff } = this.props;
        if (on) {
            onGroupToggleOn(portfolioType);
        } else {
            onGroupToggleOff(portfolioType);
        }
    }

    getContractListGroupSwitchValue(immItems) {
        for (const item of immItems) {
            if (item.get('enabled') && item.get('personalizable')) {
                return true;
            }
        }

        return false;
    }

    buildContractListGroup(immContracts, headerTitle) {
        const {
            //immIntervenersByContractId,
            editable,
            onSwitchChange,
            creatingNew
        } = this.props;

        const contracts = [];

        if (!immContracts || immContracts.length === 0) {
            return contracts;
        }

        const header = this.buildGroupHeader(immContracts, headerTitle);
        contracts.push(header);

        immContracts.forEach(item => {
            const contractName = item.get('name');
            const contractNumber = item.get('portfolioId');
            const contractNumberFormatted = item.get('portfolioIdFormatted');
            const enabled = item.get('enabled');
            const interventionType = item.get('tipoIntervencion');//immIntervenersByContractId.getIn([`00${contractNumber}`,'interventionType']);
            const personalizable = item.get('personalizable');
            let handleClick = (editable && personalizable) ? () => onSwitchChange(contractNumber) : noop;
            let toogleAvailable = !__CONTACT_CENTER__ && editable;
            let switchAvailable = enabled;
            let showUnconsolidatedTooltip = false;

            if (editable && !personalizable) {
                toogleAvailable = false;
                switchAvailable = false;
                showUnconsolidatedTooltip = true;
            }

            contracts.push(
                <BrokerCustomWalletPortfolioItem
                    key={contractNumber}
                    contractName={contractName}
                    contractNumber={contractNumber}
                    contractNumberFormatted={contractNumberFormatted}
                    interventionType={interventionType}
                    switchEnabled={switchAvailable}
                    toggleAvailable={toogleAvailable}
                    handleClick={handleClick}
                    creatingNew={creatingNew}
                    personalizable={personalizable}
                    showUnconsolidatedTooltip={showUnconsolidatedTooltip}
                />
            );
        });

        return contracts;
    }

    buildGroupHeader(immContracts, headerTitle) {
        const groupSwitch = this.buildGroupSwitch(immContracts);

        return (
            <div className="row broker-custom-wallet-grouped-portfolios__header">
                <div className="col-xs-9 broker-custom-wallet-grouped-portfolios__title">
                    {headerTitle}
                </div>
                <div className="broker-custom-wallet-grouped-portfolios__group-switch">
                    {groupSwitch}
                </div>
            </div>
        )
    }

    buildGroupSwitch(immContracts) {
        const { editable } = this.props;
        if (!editable) {
            return;
        }

        const portfolioType = immContracts[0].get('portfolioType');
        const handleGroupToggle = (on) => this.onGroupToggle(portfolioType, on);
        const switchValue = this.getContractListGroupSwitchValue(immContracts);
        return <Toggle checked={switchValue} onClick={handleGroupToggle} />;
    }

    render() {
        const { immContracts } = this.props;

        const contractsByType = {};
        immContracts.forEach(immContract => {
            const type = immContract.get('portfolioType');
            contractsByType[type] = contractsByType[type] || [];
            contractsByType[type].push(immContract);
        });

        const mappedContracts = [];
        mappedContracts.push(
            ...this.buildContractListGroup(
                contractsByType[BROKER_CUSTOM_WALLET_CONTRACT_VALORES_TYPE],
                formatText('brokerCustomWallet-valoresTypeName')
            )
        );
        mappedContracts.push(
            ...this.buildContractListGroup(
                contractsByType[BROKER_CUSTOM_WALLET_CONTRACT_FUNDS_TYPE],
                formatText('brokerCustomWallet-investmentsFundsTypeName')
            )
        );
        mappedContracts.push(
            ...this.buildContractListGroup(
                contractsByType[BROKER_CUSTOM_WALLET_CONTRACT_PLANS_TYPE],
                formatText('brokerCustomWallet-plansTypeName')
            )
        );

        return <div>{mappedContracts}</div>;
    }
}

BrokerCustomWalletGroupedPortfolios.propTypes = {
    immContracts: PropTypes.object.isRequired,
    immIntervenersByContractId: PropTypes.object.isRequired,
    editable: PropTypes.bool.isRequired,
    onSwitchChange: PropTypes.func,
    onGroupToggleOff: PropTypes.func,
    onGroupToggleOn: PropTypes.func,
    creatingNew: PropTypes.bool
};

module.exports = BrokerCustomWalletGroupedPortfolios;
